<template>
    <li>
        <a :href="articleUrl" class="item_list" target="_blank">
            <div class="thumb_g"><img :src="imageUrl" width="54" height="54" alt=""></div>
            <div class="desc_list">
                <strong class="tit_list">{{keyword}}</strong>
                <p class="txt_list">{{title}}</p>
                <p class="date_list">{{regDate}}</p>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        keyword: String,
        cafeUrl: String,
        imageUrl: String,
        title: String,
        articleUrl: String,
        searchOpen: Boolean,
        createdDate: Number,
        regDate: String
    }
}
</script>
